import IndustryPageTemplate from "./IndustryPageTemplate";
import { fitnessTrainersData } from "@/data/fitnessTrainers";

export default function FitnessTrainersPage() {
  return <IndustryPageTemplate data={fitnessTrainersData} />;
}
